export type SingleFamilySolidWasteCollectionType =
  | 'Open Market'
  | 'Automatically Provided'
  | 'Community-operated opt-in'
  | 'Community-operated opt-in (with fee)'
  | 'Other';



export type MultiFamilyCollectionType =
  | 'Open Market'
  | 'Required by Law'
  | 'Pilot'
  | 'Available from Community';

export const SINGLE_FAMILY_SOLID_WASTE_COLLECTION_TYPES: SingleFamilySolidWasteCollectionType[] = [
  'Open Market',
  'Automatically Provided',
  'Community-operated opt-in',
  'Community-operated opt-in (with fee)',
  'Other',
];

export const MULTI_FAMILY_COLLECTION_TYPES: MultiFamilyCollectionType[] = [
  'Open Market',
  'Required by Law',
  'Pilot',
  'Available from Community',
];
